/**
 * Suppress React defaultProps deprecation warnings from SVG components
 * These warnings come from svg-react-loader which generates defaultProps
 */

const originalError = console.error

console.error = (...args) => {
  // Check if it's the defaultProps warning
  if (
    typeof args[0] === 'string' &&
    args[0].includes('Support for defaultProps will be removed')
  ) {
    return // Suppress this warning
  }
  originalError.apply(console, args)
}
